export const formatPriceToUSD = (price: number): string => {
  return `$${price.toFixed(2)} USD`;
};

export const getStreamButtonText = (
  price: number,
  formatPrice: (price: number) => string,
  isInterview?: boolean,
  hasAccessToWatch?: boolean
): string => {
  if (hasAccessToWatch || price === 0) {
    return isInterview ? 'Watch Interview' : 'Watch Stream';
  }

  return isInterview
    ? `Buy Interview - ${formatPrice(price)}`
    : `Buy PPV - ${formatPrice(price)}`;
};
